import { TranslateModule } from '@ngx-translate/core';
import { AVATAR_WIDTH } from '../../../constants';
import { TranslationModule } from '../../../i18n/translation-module';
import { CollapsibleSectionComponent } from '../../collapsible-section/collapsible-section.component';
import { ActivityInterface } from '@vendasta/crm';
import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { CrmFieldService, StandardIds, SystemFieldIds } from '../../../shared-services/crm-services/field.service';
import { MatCardModule } from '@angular/material/card';
import { DateFormat } from '@vendasta/galaxy/utility/date-utils';
import { GalaxyAvatarModule } from '@vendasta/galaxy/avatar';
import { CrmUnknownUserAvatarComponent } from '../../unknown-user-avatar/unknown-user-avatar.component';
import { getActivityUrl } from './activity-url-builder';
import { SanitizeHtmlPipe } from './sanitize-html.pipe';

@Component({
  selector: 'crm-activity-communication',
  templateUrl: './activity-communication.component.html',
  styleUrls: ['./activity-communication.component.scss'],
  imports: [
    CommonModule,
    TranslateModule,
    TranslationModule,
    CollapsibleSectionComponent,
    MatCardModule,
    GalaxyAvatarModule,
    CrmUnknownUserAvatarComponent,
    SanitizeHtmlPipe,
  ],
  standalone: true,
})
export class CrmActivityCommunicationComponent {
  @Input() set activity(activity: ActivityInterface) {
    this.setActivityData(activity);
  }

  @Input() showAvatar = true;

  readonly AVATAR_WIDTH = AVATAR_WIDTH;
  readonly dateFormat = DateFormat.medium;

  sourceName = '';
  body = '';
  effectiveDate?: Date;
  activityUrl: string | null = null;
  activityUrlName = '';

  constructor(private readonly fieldService: CrmFieldService) {}

  private setActivityData(activity: ActivityInterface): void {
    this.body = this.getStringFieldData(activity, StandardIds.ActivityCommunicationBody);
    this.effectiveDate = this.fieldService.getFieldValueFromCrmObject(
      activity,
      SystemFieldIds.ActivityEffectiveDate,
    )?.dateValue;
    this.sourceName = this.getStringFieldData(activity, StandardIds.ActivitySourceName);
    this.activityUrl = getActivityUrl(this.getStringFieldData(activity, StandardIds.ActivityUrl));
    this.activityUrlName = this.getStringFieldData(activity, StandardIds.ActivityUrlName) ?? '';
  }

  private getStringFieldData(activity: ActivityInterface, fieldId: string): string {
    return this.fieldService.getFieldValueFromCrmObject(activity, fieldId)?.stringValue ?? '';
  }
}
